// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".plusIcon-svg>g{stroke:#0067dd}.plusIconDisabled-svg>g{stroke:#858585}.addFile{width:32px !important;height:32px !important}\n", ""]);
// Exports
module.exports = exports;
